import React from 'react'

import Base from '../_Base'

const Dropdown = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M7 10.1h10l-5 5z" fillRule="evenodd" />
  </Base>
)

export default Dropdown
